import { SquareArrowOutUpRight } from 'lucide-react';

export interface QuickLinkProps {
  to: string;
  label: string;
  showIcon?: boolean;
}

export const QuickLink = (props: QuickLinkProps) => {
  return (
    <a
      href={props.to}
      target="_blank"
      className="font-bold underline decoration-2 transition-colors duration-300 ease-in-out hover:text-deep-blue focus:text-deep-blue
        focus:outline-focus-ring"
    >
      {props.showIcon && <SquareArrowOutUpRight className="mr-[5px] inline h-6 w-[18px] px-0.5 pb-1 pt-0" />}
      <span>{props.label}</span>
    </a>
  );
};
